import { render, staticRenderFns } from "./basecost-setting-edit.vue?vue&type=template&id=62c6634f&"
import script from "./basecost-setting-edit.vue?vue&type=script&lang=ts&"
export * from "./basecost-setting-edit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports